export default __webpack_public_path__ + "static/media/SUMMER SALE HP BANNER (385 x 148 px).fce0016a.png";